// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconSaveJob: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 13"
            width="12"
            height="13"
        >
            <path fill="currentColor" d="M11.25,8.25 L8.12109375,8.25 L7.06054688,9.31054688 C6.77812529,9.59296846 6.40078139,9.75 6,9.75 C5.59921861,9.75 5.22281241,9.59399986 4.93945312,9.31054688 L3.87890625,8.25 L0.75,8.25 C0.335859418,8.25 0,8.58585906 0,9 L0,11.25 C0,11.6641409 0.335859418,12 0.75,12 L11.25,12 C11.6641409,12 12,11.6641409 12,11.25 L12,9 C12,8.58515596 11.664844,8.25 11.25,8.25 Z M10.125,10.6875 C9.81562471,10.6875 9.5625,10.4343753 9.5625,10.125 C9.5625,9.81562471 9.81562471,9.5625 10.125,9.5625 C10.4343753,9.5625 10.6875,9.81562471 10.6875,10.125 C10.6875,10.4343753 10.4343753,10.6875 10.125,10.6875 Z M5.47031236,8.77968764 C5.61562514,8.92734361 5.80781257,9 6,9 C6.19218779,9 6.38390636,8.92675781 6.53015614,8.78027344 L9.53015614,5.78027344 C9.82289028,5.48730469 9.82289028,5.01269531 9.53015614,4.71972656 C9.23718739,4.42675781 8.76234341,4.42675781 8.46960926,4.71972656 L6.75,6.44062471 L6.75,0.75 C6.75,0.33585906 6.41414094,0 6,0 C5.58515632,0 5.25,0.33585906 5.25,0.75 L5.25,6.44062471 L3.52968764,4.72031236 C3.23695314,4.42734361 2.76210952,4.42734361 2.46914077,4.72031236 C2.17640626,5.01328111 2.17640626,5.48789048 2.46914077,5.78085923 L5.47031236,8.77968764 Z" transform="translate(0 .5)"/>
        </svg>
    );
};

export default React.memo(IconSaveJob);
